module.exports = __webpack_public_path__ + "img/微信图片_20251028123237_208_595.21da856f.jpg";